(function () {
  'use strict';

  function syncExpanded(details) {
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function initReturnsPage(root) {
    if (!root || root.dataset.returnsReady === 'true') return;
    root.dataset.returnsReady = 'true';

    var disclosures = Array.prototype.slice.call(root.querySelectorAll('[data-returns-disclosure]'));
    disclosures.forEach(function (details) {
      var summary = details.querySelector('summary');
      syncExpanded(details);

      details.addEventListener('toggle', function () {
        syncExpanded(details);
        if (!details.open) return;
        var group = details.closest('[data-returns-accordion-group]');
        if (!group) return;
        Array.prototype.forEach.call(group.querySelectorAll('[data-returns-disclosure][open]'), function (sibling) {
          if (sibling !== details) {
            sibling.open = false;
            syncExpanded(sibling);
          }
        });
      });

      details.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && event.target === summary) {
          event.preventDefault();
          details.open = !details.open;
          syncExpanded(details);
          return;
        }
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          details.open = false;
          syncExpanded(details);
          summary.focus();
        }
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-returns-page]'), initReturnsPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
